export default "__VITE_ASSET__D9H4XgJt__"